import { cn } from '../../utils/cn';

/**
 * Skeleton — lazy load placeholder. Gerçek içeriğin yerini tutacak şekilde
 * boyutlandırılmış nötr bir pulse bloğu. Dashboard kartları ve tablo satırları
 * data gelene kadar bu bileşenle doldurulur; böylece layout "sıçramadan"
 * yerinde oturuyor ve sayfa açılışı "yükleniyor…" metninden daha hızlı
 * hissediliyor.
 *
 * Kullanım:
 *   <Skeleton className="h-4 w-32" />
 *   <Skeleton circle className="h-10 w-10" />
 */
export default function Skeleton({ className, circle = false }) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'animate-pulse bg-neutral-200/80',
        circle ? 'rounded-full' : 'rounded-md',
        className,
      )}
    />
  );
}

/**
 * Birden fazla kısa çizgiden oluşan bir paragraf placeholder'ı.
 * `lines` tanesini, sonuncuyu biraz daha kısa tutarak render eder.
 */
export function SkeletonLines({ lines = 3, className }) {
  return (
    <div className={cn('space-y-2', className)}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          className={cn('h-3', i === lines - 1 ? 'w-2/3' : 'w-full')}
        />
      ))}
    </div>
  );
}

/**
 * StatCard'ın skeleton karşılığı — aynı boyut/padding, label + value +
 * alt satır yeri + sağda icon placeholder. Dashboard stat grid'inde kullanılır.
 */
export function SkeletonStatCard() {
  return (
    <div className="rounded-xl border border-neutral-200 bg-white p-5 shadow-sm">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <Skeleton className="h-3 w-20" />
          <Skeleton className="mt-2 h-7 w-16" />
          <Skeleton className="mt-2 h-3 w-24" />
        </div>
        <Skeleton className="h-10 w-10" />
      </div>
    </div>
  );
}
